// This file is used for the standalone browser build

import Drift from "2"

window["Drift"] = Drift;
